import { render, staticRenderFns } from "./ReceptorCodigos.vue?vue&type=template&id=44495c96&scoped=true&"
import script from "./ReceptorCodigos.vue?vue&type=script&lang=ts&"
export * from "./ReceptorCodigos.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptorCodigos.vue?vue&type=style&index=0&id=44495c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44495c96",
  null
  
)

export default component.exports